import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './error/not-found/not-found.component';
import { FullLayoutComponent } from './layouts/full-layout.component';
import { AuthPageComponent } from './manage-user/auth-page/auth-page.component';
import { NotAuthorizedAdminGuard } from './shared/services/guards/not-authorized-admin-guard';
import { AuthGuard } from './shared/guards/auth.guard';
import { FormBankerComponent } from './form-banker/form-banker.component';
import { ListBankerComponent } from './list-banker/list-banker.component';
import { AppointmentsListComponent } from './appointments-list/appointments-list.component';
import { ListCollaborateurComponent } from './collaborateur/components/collaborateur-list/collaborateur-list.component';
import { FormCollaborateurComponent } from './collaborateur/components/form-collaborateur/form-collaborateur.component';
import { ListSecteurActiviteComponent } from './secteur-activite/components/list-secteur-activite/list-secteur-activite.component';
import { FormSecteurActiviteComponent } from './secteur-activite/components/form-secteur-activite/form-secteur-activite.component';
import { StatsEricComponent } from './collaborateur/components/stats-eric/stats-eric.component';
import { StatsYvanComponent } from './collaborateur/components/stats-yvan/stats-yvan.component';
import { Privilege9Guard } from './shared/guards/privilege9.guard';
import { StatsJuvenalComponent } from './collaborateur/components/stats-juvenal/stats-juvenal.component';
import { StatsExpertComponent } from './collaborateur/components/stats-expert/stats-expert.component';
import { SendPaymentComponent } from './send-payment/send-payment.component';
import { PaymentRequestsComponent } from './payment-requests/payment-requests.component';

export const routes: Routes = [
    {
        path: '',
        component: FullLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'admins',
                loadChildren: () => import('./client/client.module').then(m => m.ClientModule)
            },
            {
                path: 'manage-mail',
                loadChildren: () => import('./manage-mail/manage-mail.module').then(m => m.ManageMailModule)
            },
            {
                path: 'manage-offre',
                loadChildren: () => import('./manage-offre/manage-offre.module').then(m => m.ManageOffreModule)
            },
            {
                path: 'manage-menu',
                loadChildren: () => import('./manage-menu/manage-menu.module').then(m => m.ManageMenuModule)
            },
            {
                path: 'manage-projects',
                loadChildren: () => import('./manage-projects/manage-projects.module').then(m => m.ManageProjectsModule)
            },
            {
                path: 'manage-users',
                loadChildren: () => import('./manage-users/manage-users.module').then(m => m.ManageUsersModule)
            },
            {
                path: 'manage-configuration',
                loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule)
            },
            { path: 'add-banker', component: FormBankerComponent },
            { path: 'list-bankers', component: ListBankerComponent },
            { path: 'bankers/:id/edit', component: FormBankerComponent },
            { path: 'appointments', component: AppointmentsListComponent },
            { path: 'collaborateurs', component: ListCollaborateurComponent },
            { path: 'collaborateurs/add',    component: FormCollaborateurComponent },
            { path: 'collaborateurs/:id/edit', component: FormCollaborateurComponent },
            { path: 'secteurs-activite', component: ListSecteurActiviteComponent },
            { path: 'secteurs-activite/add',       component: FormSecteurActiviteComponent },
            { path: 'secteurs-activite/:id/edit',  component: FormSecteurActiviteComponent },
            { path: 'stats/eric', component: StatsEricComponent },
            { path: 'stats/yvan', component: StatsYvanComponent },
            { path: 'stats/expert',  component: StatsExpertComponent },
            { path: 'stats/juvenal', component: StatsJuvenalComponent },
            { 
                path: '', 
                component: StatsEricComponent, 
                canActivate: [Privilege9Guard]  // ← ici
            },
            { path: 'send-payment', component: SendPaymentComponent },
            { path: 'payment-requests', component: PaymentRequestsComponent },

        ],
    },
    {
        path: 'auth',
        loadChildren: () => import('./manage-user/manage-user.module').then(m => m.ManageUserModule),
        canActivate: [NotAuthorizedAdminGuard]
    },
    {
        path: 'admin/auth',
        component: AuthPageComponent,
        canActivate: [NotAuthorizedAdminGuard]
    },
    { path: '**', component: NotFoundComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
